var render = function render(){var _vm=this,_c=_vm._self._c;return _c('three-step-history',{attrs:{"api":"home-delete-request","columns":_vm.columns,"done-word":"ລຶບແລ້ວ"}})
}
var staticRenderFns = []

export { render, staticRenderFns }